import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionUnAuth, serviceCall } from '../../serviceCall'

export const registerUserViaThirdPartyApp = (data, callback, errorCallBack) => {

    return async (dispatch) => {

        formDataCommonFunctionUnAuth(data, apiConstants.AUTH.REGISTER_USER_VIA_THIRD_PARTY_APP)
            .then((response) => {
                callback && callback(response)

            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}